// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__XiqYu","LoveText":"Footer_LoveText__v7jpb","ContactInfo":"Footer_ContactInfo__ZMY1i"};